module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/TriumphandDefeat_prefaceandacknowledgments#prefaceandacknowledgments"
    }
  }, [_vm._v("Preface and Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/TriumphandDefeat_foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/TriumphandDefeat_ch1#chapter1"
    }
  }, [_vm._v("Chapter 1: Beyond the Rubicon: The Union Army Secures Its Beachhead on Mississippi Soil")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/TriumphandDefeat_ch2#chapter2"
    }
  }, [_vm._v("Chapter 2: Blitzkrieg: Grant Style")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch3#chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The National Colors Are Restored O’er the Capitol")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch4#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: John A. McClernand: Fighting Politician")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch5#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Companion to the Fishes: The Saga of the Gunboat Cincinnati")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch6#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Lords of Vicksburg")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch7#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: “I Am Too Late:” Joseph E. Johnston and the Army of Relief")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch8#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: “No Longer A Point of Danger:” The Siege of Jackson")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch9#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Crucial to the Outcome: Vicksburg and the Trans-Mississippi Supply Line")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_ch10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Stephen D. Lee and the Making of an American Shrine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/TriumphandDefeat_bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter2"
  }, [_vm._v("Maps and illustrations have been distributed throughout the text for the convenience of the reader.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264bd0aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TriumphandDefeat_toc.vue
// module id = 72
// module chunks = 0